export const validateTag = async (api: any, tagName: string) => {
  try {
    const res = await api.getPublic(`tag/${tagName}`, {maxRedirects: 0});
    if (res.status === 200 && res.data.concept) {
      const conceptNHSMap: { [key: string]: string } = {
        'CONDITION': 'conditions',
        'TREATMENT': 'medicines',
      };
      const tagType = conceptNHSMap[res.data.concept];
      return { success: true, tagType, longName: res.data.longName };
    }
  } catch (ex) {
    if (ex.response.status === 301) {
      return { success: false, redirect: true, location: ex.response.headers.location };
    }
    return { success: false, status: ex.response.status };
  }
  return { success: false, status: 500 };
};
